<div class="messages-datetime-separator">
  <div class="messages-datetime">{{ getFormattedDate(day) }}</div>
</div>
<div class="message-holder" *ngFor="let message of sortedMessages">
  <app-chat-message
    [message]="message">
  </app-chat-message>
</div>
